module.exports = __webpack_public_path__ + "static/media/CrackingTheCodingInterview.c7934311.png";